import { createClient } from 'helpers/createClient';
import { ServerSidePropsType } from 'helpers/InitServerSideProps';
import { isClient } from 'helpers/isServer';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { ssrExchange as createSsrExchange, Provider, SSRExchange } from 'urql';

let ssrExchange: SSRExchange | null = null;

export const UrqlWrapper: FC<{ pageProps: ServerSidePropsType }> = ({ children, pageProps }) => {
    const { publicGraphqlEndpoint } = pageProps.domainConfig;
    const { t } = useTranslation();

    const client = useMemo(() => {
        if (!ssrExchange || typeof window === 'undefined') {
            ssrExchange = createSsrExchange({
                initialState: pageProps.urqlState,
                isClient: isClient,
            });
        } else {
            ssrExchange.restoreData(pageProps.urqlState);
        }

        return createClient({ t, ssrExchange, publicGraphqlEndpoint });
    }, [pageProps.urqlState]);

    return <Provider value={client}>{children}</Provider>;
};
